import { render, staticRenderFns } from "./ComradeMain.vue?vue&type=template&id=cdec39b2&scoped=true"
import script from "./ComradeMain.vue?vue&type=script&lang=js"
export * from "./ComradeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdec39b2",
  null
  
)

export default component.exports